import React, { useRef, useState } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';

interface Props {
  onSwitchProperties: () => void;
  onUpdatePropertyType: () => void;
  onBlacklistProperties: () => void;
}

interface BulkOperation {
  id: string;
  label: string;
  onClick: () => void;
}

function GHABulkOperationsMenu({ onSwitchProperties, onUpdatePropertyType, onBlacklistProperties }: Props) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (anchorRef.current?.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };

  const handleOperationClick = (operation: BulkOperation) => {
    operation.onClick();
    setOpen(false);
  };

  const bulkOperations: Array<BulkOperation> = [
    {
      id: 'switch-properties',
      label: 'Switch GHA Properties',
      onClick: onSwitchProperties,
    },
    {
      id: 'update-property-type',
      label: 'Update Property Type',
      onClick: onUpdatePropertyType,
    },
    {
      id: 'blacklist-properties',
      label: 'Blacklist Properties',
      onClick: onBlacklistProperties,
    },
    // Future operations can be easily added here
  ];

  return (
    <>
      <Button
        ref={anchorRef}
        variant="contained"
        endIcon={<ArrowDropDownIcon />}
        onClick={handleToggle}
        aria-controls={open ? 'bulk-operations-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="menu"
      >
        Bulk Operations
      </Button>
      <Popper open={open} anchorEl={anchorRef.current} placement="bottom-end" transition sx={{ zIndex: 'modal' }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'right top' : 'right bottom',
            }}
          >
            <Paper elevation={1}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="bulk-operations-menu" autoFocusItem>
                  {bulkOperations.map((operation) => (
                    <MenuItem key={operation.id} onClick={() => handleOperationClick(operation)}>
                      {operation.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default GHABulkOperationsMenu;
